import { FC, useCallback, useEffect, useMemo, useState, useRef } from "react";
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../../setup'
import { callSP, getFlaskRunPlantilla, getFlaskRunMinuta } from "../../../../setup/axios/AxiosCallSP";
import { LunchGrid } from "../../../utils/lunchGrid/LunchGrid";
import { ModalForm } from "../../../utils/modal/ModalForm";
import { itemSelec } from "../grillas/Grilla1";
import { getDataColunMinutaVertical } from "../minutaFood/services/serviceMinutaFood/serviceMinutaFood";
import { columnDetailModal, columnModalValidate, createMinutaRow, getOrderHeader, getOrderRow, informationPlanings, inputMinutaModal, replicacionContrato, runPlantilla, validateSchemaModal } from "./serviceMinutaVertical/ServiceMinutaVertical";
import Autocomplete from '@mui/material/Autocomplete'
import { Checkbox, TextField } from '@mui/material'
import { Modal, Button } from 'react-bootstrap'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import { HeadLunchGrid } from '../../../utils/lunchGrid/HeadLunchGrid'
import { AlertModal, AlertModalProps } from '../../../utils/modal/AlertModal'
import { useLocation, useNavigate } from 'react-router-dom'
import { exportTableToExcel, getLStorage, groupBy, setLStorage } from "../../../../global.d";
import { getUserByToken } from 'app/helpers/getUserByToken'
import { error, success, warn } from '../../../utils/customToasd'
import * as contract from '../../redux/ContractRedux';
import { Loading } from "../../../utils/loadingR/Loading";
import { quitarDuplicadoReceta } from '../grillas/gridService'

// ==========================
// Estado para ENROQUE VISUAL (2 clics) 
// ==========================
type FirstSwap = {
  idGrid: number;     
  numRow: number;     
  idColumn: number;   
  nombreEstructura?: string; 
} | null

interface MinutaVerticalProps {
  setAlertModal?: any
}

// ==========================
// Helpers locales
// ==========================
const deepCopy = <T,>(o: T): T => JSON.parse(JSON.stringify(o))

const getFieldValue = (row: any, base: string, colId: number) => {
  const key = base + colId
  return row?.[key]
}

const setFieldValue = (row: any, base: string, colId: number, val: any) => {
  const key = base + colId
  row[key] = val
}

// Solo lo que “cambia de menú”, no metadatos ni llaves
const CAMPOS_X_COL = [
  'idIngredientePrincipal',
  'Nombretipoingprincipal',
  'icon',
  'color',
]

// Tope de cambios sin guardar en plantilla. Pasado este umbral se fuerza guardar
// para evitar que la vista se vaya a blanco con muchos cambios acumulados (TK 35844).
const MAX_PENDING_CHANGES_PLANTILLA = 15


// Bloquea solo si RecFija > 0 (soporta RecFija/recfija con o sin sufijo por columna)
const isCellBlocked = (row: any, col: number): boolean => {
  const k = String(col)
  const raw =
    row?.['RecFija' + k] ??
    row?.['recfija' + k] ??
    row?.RecFija ??
    row?.recfija ??
    0
  return Number(raw) > 0
}


const MinutaVertical: FC<MinutaVerticalProps> = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const info: any = useSelector<RootState>(({ auth }) => auth.user, shallowEqual)
  const accessToken: any = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual)
  const location = useLocation()

  const icon = <CheckBoxOutlineBlankIcon fontSize='small' />
  const checkedIcon = <CheckBoxIcon fontSize='small' />

  const [params, setParams] = useState<any>()
  const [dataHeader, setDataHeader] = useState<any>([])
  const [dataRow, setDataRow] = useState<any>([])
  const [dataRowModal, setDataRowModal] = useState<any>([])
  const [showSaveSend, setShowSaveSend] = useState(false)
  const [infoModal, setInfoModal] = useState<boolean>(false)
  const [showModalMenu, setShowModalMenu] = useState(false)
  const [showIdP, setShowIdP] = useState<boolean>(false)
  const [leyend, setLeyend] = useState<boolean>(false)

  // ⚠️ IMPORTANTE: este "color" sigue como en tu app (lo prende el usuario).
  // Ya no afecta a los resaltados amarillo/azul.
  const [color, setColor] = useState<boolean>(false)

  const [icono, setIcono] = useState<boolean>(false)
  const [normal, setNormal] = useState<boolean>(false)
  const [precio, setPrecio] = useState<boolean>(false)
  const [load, setLoad] = useState<boolean>(false)
  const [_checked, _setChecked] = useState<boolean>(true)
  const [minDateHasta, setMinDateHasta] = useState<any>(null)
  const [idIngredientePrincipal, setIdIngredientePrincipal] = useState<any>({
    idIngrediente: 0,
    idColumn: 0,
    id_receta: 0,
  })
  const [dataDetalle, setDataDetalle] = useState<any>([])
  const [rowLunchGrid, setRowLunchGrid] = useState<any>([])
  const [columnLunchGrid, setColumnLunchGrid] = useState<any>([])
  const [datatableCol, setDatatableCol] = useState<any>([])
  const [structureSelected, setstructureSelected] = useState<any>([])
  const [colorSelected, setColorSelected] = useState<any>([])
  const [grupoEstructura, setGrupoExtructura] = useState<any>([])
  const [recetasbyContrato, setRecetasbyContrato] = useState<any[]>()
  
  // Contador para sampling inteligente del stack de undo
  const changeCountRef = useRef<number>(0)
  const lastSaveTimeRef = useRef<number>(Date.now())
  const [recetasbyContratoFilter, setRecetasbyContratoFilter] = useState<any[]>()
  const [isUndo, setIsUndo] = useState<boolean>(false)
  const [isUndoAll, setIsUndoAll] = useState<boolean>(false)
  const [title, setTitle] = useState<string>("");
  const [changesData, setChangesData] = useState<any[]>([])
  const [alertModal, setAlertModal] = useState<AlertModalProps>();
  const [sitios, setSitios] = useState<any[]>([])
  const [servicios, setServicios] = useState<any[]>([])
  const [regimens, setRegimens] = useState<any[]>([])
  const [estContrato, setEstContrato] = useState<any[]>([])
  const [_initialValues, setInitialValues] = useState<any>([])
  const [isExportExternal, setIsExportExternal] = useState<boolean>(false)
  const [colorGrupoEstructura, setColorGrupoEstructura] = useState<any>();
  const [optionColor] = useState<any>([
    { color: '#DD9255', text: 'color 1' },
    { color: '#FFC107', text: 'color 2' },
    { color: '#AA4035', text: 'color 3' },
    { color: '#35A872', text: 'color 4' }
  ])
  const [initValue, setInitValue] = useState<any>({ desde: '', hasta: '' })

  const inputSwich = {
    cabecera: true,
    estructura: false,
    estructuraFija: false,
    recetaFija: false,
    frecuenciaIngredientes: false,
    reglas: false,
    plantilla: false,
    seleccionarEstructura: false,
  }

  // === NUEVO: enroque visual y resaltados independientes del modo color ===
  const [swapMode, setSwapMode] = useState<boolean>(false)
  const [firstSwap, setFirstSwap] = useState<FirstSwap>(null)

  // claves de celdas -> "g-r-c"
  const keyOf = useCallback((g: number, r: number, c: number) => `${g}-${r}-${c}`, [])
  const [firstHighlightKey, setFirstHighlightKey] = useState<string | null>(null)
  const [highlightKeys, setHighlightKeys] = useState<Set<string>>(new Set())

  const pendingChanges = useMemo(() => changesData.length, [changesData])

  // Contexto plantilla: la regla de guardado obligatorio cada N cambios solo
  // aplica acá, no en minuta normal.
  const isPlantillaContext = useMemo(
    () => location.pathname.toLowerCase().includes('plantilla'),
    [location.pathname]
  )
  const [forceSaveModal, setForceSaveModal] = useState<boolean>(false)

  // ==========================
  // Carga inicial
  // ==========================
  const getDataInit = async () => {
    try {
      setMinDateHasta(null)
      setLoad(true)
      const [
        listaIngredientes,
        planillaContrato,
        cabeceraContrato,
        estructuraContrato,
        dataRModal,
        dataEstContrato,
        dataSitios,
        dataRegimen
      ] = await Promise.all([
        callSP('amd_getIngredientesPlantillaByContrato', [{ text: 'contrato', value: params.id.toString() }]),
        callSP('amd_getPlantillaByContrato', [{ text: 'contrato', value: params.id.toString() }]),
        callSP('amd_getCabeceraPlantillaByContrato', [{ text: 'contrato', value: params.id.toString() }]),
        callSP('amd_getEstructuraPlantillaByContrato', [{ text: 'contrato', value: params.id.toString() }]),
        callSP('amd_cuadroResumenIngredientes', [{ text: 'contrato', value: params.id.toString() }]),
        callSP('amd_getEstructuraByContrato', [{ text: 'contrato', value: params.id.toString() }]),
        callSP('amd_getSitio', []),
        callSP('amd_getRegimen', [])
      ])

      setEstContrato(
        dataEstContrato.data.result
          .filter((e: any) => ![1, 2, 3, 4].includes(e.id))
          .map((e: any) => ({ ...e, text: e.nombre, value: e.id }))
      )

      setSitios(dataSitios.data.result.map((e: any) => ({ ...e, text: e.cli_nombre, value: e.cli_codigo })))
      setRegimens(dataRegimen.data.result.map((e: any) => ({ ...e, text: e.reg_nombre, value: e.reg_codigo })))
      setDataRowModal(dataRModal.data.result)
      setRecetasbyContrato(listaIngredientes.data.result)

      const dataR = getOrderRow(planillaContrato.data.result, estructuraContrato.data.result);
      const dataGrupoColor: any = []
      planillaContrato.data.result.forEach((item: any) => {
        if (dataGrupoColor[item.nombreEstructura] === undefined) dataGrupoColor[item.nombreEstructura] = "";
        dataGrupoColor[item.nombreEstructura] = item.colorGrupoEstructura
      })
      setColorGrupoEstructura(dataGrupoColor);
      setDataRow(dataR)
      setDataHeader(getOrderHeader(cabeceraContrato.data.result))
      setGrupoExtructura(estructuraContrato.data.result)
      setLoad(false)
    } catch (err) {
      setLoad(false)
      Promise.reject(err);
    }
  }

  useEffect(() => {
    const data = recetasbyContrato?.filter(
      (item) => item.id_grupo_estructura === idIngredientePrincipal.id_grupo_estructura
    )
    if (recetasbyContrato) {
      setRecetasbyContratoFilter(quitarDuplicadoReceta(data, 'id_ingrediente_principal'))
    }
  }, [showIdP, idIngredientePrincipal, recetasbyContrato])

  useEffect(() => {
    if (params) {
      getDataInit()
      setDatatableCol(getDataColunMinutaVertical(filter))
    }
  }, [params])

  const notify = () => {
    success('Planilla guardada con exito!')
  }

  // ==========================
  // Guardado a BD (usa cola immutable changesData)
  // ==========================
  const onSave = async () => {
    // de-dup por (id, id_ingrediente)
    const unique = new Map<string, { id: string; id_ingrediente: string; id_usuario: string }>();
    for (const ch of changesData) {
      const k = `${ch.id}-${ch.id_ingrediente}`;
      unique.set(k, {
        id: String(ch.id),
        id_ingrediente: String(ch.id_ingrediente),
        id_usuario: info?.id ? String(info.id) : '1',
      });
    }
    const toSave = Array.from(unique.values());

    if (!toSave.length) {
      warn('No hay cambios que guardar!');
      return;
    }

    try {
      setLoad(true);
      await Promise.all(
        toSave.map(ch =>
          callSP('amd_guardarPlantilla', [
            { text: 'id',            value: ch.id },
            { text: 'id_ingrediente', value: ch.id_ingrediente },
            { text: 'id_usuario',     value: ch.id_usuario },
          ])
        )
      );

      // 👉 NO llames getDataInit() aquí (eso te revierte visualmente)
      // Sólo limpia el buffer de cambios y muestra OK.
      setChangesData([]);
      setForceSaveModal(false);
      success('Planilla guardada con exito!');
    } catch (_e) {
      warn('No se pudo guardar la planilla');
    } finally {
      setLoad(false);
    }
  };

  // Forzar guardado cada MAX_PENDING_CHANGES_PLANTILLA cambios en plantilla.
  useEffect(() => {
    if (isPlantillaContext && changesData.length >= MAX_PENDING_CHANGES_PLANTILLA) {
      setForceSaveModal(true)
    }
  }, [changesData.length, isPlantillaContext])


  // ==========================
  // Reemplazo por modal (flujo original)
  // ==========================
  const filter = useCallback(
    async (params: any) => {
      const ing = localStorage.getItem('ingredienteSeleccionado')
      if (!ing) return
      const data: itemSelec = JSON.parse(ing)

      setRowLunchGrid((prev: any) => {
        const next = deepCopy(prev)

        if (data.idGrid !== undefined) {
          const grid = next[data.idGrid]
          const row = grid[data.numRow]

          if (getFieldValue(row, 'fecha', data.idColumn) === data.fecha) {
            setFieldValue(row, 'id_ingrediente_principal', data.idColumn, params.data.id_ingrediente_principal)
            setFieldValue(row, 'idIngredientePrincipal',  data.idColumn, params.data.id_ingrediente_principal)
            setFieldValue(row, 'Nombretipoingprincipal',  data.idColumn, params.data.Nombretipoingprincipal)
            setFieldValue(row, 'icon',                    data.idColumn, params.data.icono)

            const idPlantilla = getFieldValue(row, 'idPlantilla', data.idColumn)
            const userId = info?.id ? String(info.id) : '1'
            setChangesData((prevC) => [
              ...prevC,
              {
                id: idPlantilla?.toString(),
                id_ingrediente: params.data.id_ingrediente_principal.toString(),
                id_usuario: userId,
              }
            ])

            // Sistema inteligente: guardar siempre cambios importantes (selección de ingrediente)
            // pero con límite aumentado a 100 para manejar muchos cambios
            try {
              const currentStack = JSON.parse(getLStorage('dataRowMinuta') || '[]') || []
              const MAX_STACK_SIZE = 150
              const limitedStack = currentStack.slice(0, MAX_STACK_SIZE - 1) // Mantener espacio para el nuevo
              setLStorage('dataRowMinuta', JSON.stringify([next, ...limitedStack]))
              changeCountRef.current += 1
              lastSaveTimeRef.current = Date.now()
            } catch (error: any) {
              console.warn('Error al guardar en stack de undo:', error)
              // Intentar guardar solo el nuevo estado
              try {
                setLStorage('dataRowMinuta', JSON.stringify([next]))
                changeCountRef.current += 1
                lastSaveTimeRef.current = Date.now()
              } catch (finalError) {
                console.error('Error crítico al guardar en stack:', finalError)
              }
            }
          }
        }
        setShowModalMenu(false)
        return next
      })
    },
    [info]
  )

  // ==========================
  // Inicialización por ruta
  // ==========================
  useEffect(() => {
    const state: any = location.state
    if (state?.params) {
      dispatch(contract.actions.setInfo(true))
      setParams(state?.params)
      setLStorage('dataContratoGrilla', JSON.stringify(state?.params))
      dispatch(contract.actions.setInfoPlantilla(state?.params))
    }
    return () => {
      dispatch(contract.actions.setInfo(false))
      dispatch(contract.actions.setInfoPlantilla(undefined))
    }
  }, [])

  // ==========================
  // Construye filas/columnas para el grid
  // ==========================
  useEffect(() => {
    let data: any = []
    let header: any = []
    dataHeader?.forEach((item: any) => {
      item?.forEach((item2: any) => {
        const dataRowFilter = createMinutaRow(item2, dataRow, structureSelected)
        dataRowFilter.forEach(row => {
          if (row.order1 === undefined) {
            Object.keys(row).forEach((key: any) => {
              if (key.indexOf("order") > -1) {
                if (typeof (row[key]) === 'number')
                  row.order1 = row[key]
              }
            })
          }
        })
        const result = groupBy(dataRowFilter, "order1");
        const orderArray: any = Object.values(result).map((item: any) => item[0])
        header.push(item2)
        data.push(orderArray)
      })
    })
    setRowLunchGrid(data)
    
    // Sistema inteligente de sampling para manejar muchos cambios (hasta 400+)
    // Guarda solo cada N cambios o después de una pausa para optimizar el almacenamiento
    const now = Date.now()
    const timeSinceLastSave = now - lastSaveTimeRef.current
    changeCountRef.current += 1
    
    // Guardar si:
    // 1. Han pasado más de 2 segundos desde el último guardado (pausa en cambios)
    // 2. Es cada 8vo cambio (sampling para manejar 400 cambios con ~50 estados)
    // 3. Es el primer cambio (estado inicial importante)
    const shouldSave = 
      changeCountRef.current === 1 || // Primer cambio siempre se guarda
      timeSinceLastSave > 2000 || // Pausa de 2 segundos
      changeCountRef.current % 8 === 0 // Cada 8 cambios
    
    if (shouldSave) {
      const saveTimeout = setTimeout(() => {
        // Guardar con manejo de errores y limitación inteligente del stack
        try {
          const currentStack = JSON.parse(getLStorage('dataRowMinuta') || '[]') || []
          // Aumentar límite a 100 elementos con sampling inteligente para manejar 400+ cambios
          const MAX_STACK_SIZE = 100
          const limitedStack = currentStack.slice(0, MAX_STACK_SIZE - 1) // Mantener espacio para el nuevo
          setLStorage("dataRowMinuta", JSON.stringify([data, ...limitedStack]))
          lastSaveTimeRef.current = Date.now()
        } catch (error: any) {
          // Si falla, intentar guardar solo el estado actual
          console.warn('Error al guardar dataRowMinuta, guardando solo el estado actual:', error)
          try {
            setLStorage("dataRowMinuta", JSON.stringify([data]))
            lastSaveTimeRef.current = Date.now()
          } catch (finalError) {
            console.error('Error crítico al guardar dataRowMinuta:', finalError)
            warn('No se pudo guardar el estado en el almacenamiento local. Los cambios pueden perderse al recargar la página.')
          }
        }
      }, 300) // Debounce más corto para cambios importantes
      
      setColumnLunchGrid(header)
      
      return () => {
        clearTimeout(saveTimeout)
      }
    } else {
      // No guardar este cambio, solo actualizar la vista
      setColumnLunchGrid(header)
    }
  }, [dataHeader, structureSelected, dataRow])

  // ==========================
  // Modal de validaciones
  // ==========================
  useEffect(() => {
    props.setAlertModal?.(undefined)
    if (dataDetalle.length) {
      props.setAlertModal?.({
        title: 'Detalle Validación',
        message: ``,
        colum: columnModalValidate(),
        rows: dataDetalle,
        showSave: false,
        showAddButton: false,
        close: () => {
          props.setAlertModal(undefined)
        },
        save: async (_value: any, _setFieldValue: any, _formikProps: any) => {
          props.setAlertModal(undefined)
        },
      })
    }
  }, [dataDetalle])

  // ==========================
  // Undo / Undo All
  // ==========================
  const undo = async () => {
    try {
      const dataRowMinuta = await getLStorage('dataRowMinuta');
      if (dataRowMinuta !== null) {
        const dataR = JSON.parse(dataRowMinuta);
        if (Array.isArray(dataR) && dataR.length > 1) {
          const newData = dataR.slice(1);
          try {
            setLStorage('dataRowMinuta', JSON.stringify(newData));
            setRowLunchGrid(newData[0])
          } catch (error: any) {
            console.warn('Error al guardar después de undo:', error)
            // Aún así, actualizar la vista con el nuevo estado
            setRowLunchGrid(newData[0])
          }
        }
      }
    } catch (error) {
      console.error('Error en undo:', error)
      warn('Error al deshacer el cambio. Por favor, intente nuevamente.')
    }
  }
  const undoAll = async () => {
    try {
      const dataRowMinuta = await getLStorage('dataRowMinuta');
      if (dataRowMinuta !== null) {
        const dataR = JSON.parse(dataRowMinuta);
        const undoAllDR = dataR[dataR.length - 1];
        setRowLunchGrid(undoAllDR)
        try {
          setLStorage('dataRowMinuta', JSON.stringify([undoAllDR]));
        } catch (error: any) {
          console.warn('Error al guardar después de undoAll:', error)
          // La vista ya se actualizó, solo mostrar advertencia
          warn('El estado se restauró pero no se pudo guardar en el almacenamiento local.')
        }
      }
    } catch (error) {
      console.error('Error en undoAll:', error)
      warn('Error al restaurar todos los cambios. Por favor, intente nuevamente.')
    }
  }
  useEffect(() => { undo() }, [isUndo])
  useEffect(() => { undoAll() }, [isUndoAll])

  // ==========================
  // Carga servicios para modal
  // ==========================
  const getServices = useCallback(async (ceco: number, setFieldValue: any, values: any, _input: any, est: any[]) => {
    try {
      const dataServices: any = await callSP('amd_getServiciosByCeco', [{ text: 'ceco', value: ceco.toString() }])
      const cty = await callSP('amd_getSitio', [])
      const dataRegimen = await callSP('amd_getRegimen', [])

      const sit = cty.data.result.map((e: any) => ({ ...e, text: e.cli_nombre, value: e.cli_codigo }))
      const regi = dataRegimen.data.result.map((e: any) => ({ ...e, text: e.reg_nombre, value: e.reg_codigo }))
      const dataServ: any = dataServices.data.result.map((e: any) => ({ ...e, text: e.ser_nombre, value: e.ser_codigo }))

      setAlertModal(inputMinutaModal(sit, getServices, dataServ, regi, setLoad, setAlertModal, inputSwich, est))
      setTimeout(() => {
        setFieldValue("place", values.place);
        setFieldValue("cabecera", false);
        setFieldValue("seleccionarEstructura", false);
        setLoad(false)
      }, 300);
    } catch (e: any) {
      setLoad(false)
    }
  }, [alertModal])

  const onNewTemplate = async (id: any) => {
    setInitialValues({
      structure2: [{ text: "", value: "" }],
      estructura: [{ text: "", value: "" }],
    })
    const macroEstructura = await callSP("amd_getGrupoEstructurasByContrato", [{ text: 'contrato', value: params.id.toString() }])
    const estructura = await callSP("amd_getEstructurasByContrato", [{ text: 'contrato', value: params.id.toString() }])

    const me = macroEstructura.data.result.map((e: any) => ({ ...e, text: e.Nombre, value: e.IdGrupoEstructura }))
    const es = estructura.data.result.map((e: any) => ({ ...e, text: e.estructura, value: e.id }))
    const titleModal = "Regenerar Plantilla";
    setAlertModal({
      title: titleModal,
      message: "",
      arrayInput: [
        {
          columInput: 2,
          campo: 'estructura2',
          label: 'Macro Estructura',
          type: 'autocomplete',
          advanceOptions: { id: 'estructura', placeholder: 'Ingrese macro estructura', multiple: true, options: me },
          onChange: async (_event: any, setFieldValue: any, values: any) => {
            if (values['estructura2']?.length) {
              if (values['estructura2'].findIndex((e: any) => e.value === -1) !== -1) {
                setFieldValue('macroEstructura', es)
              }
            }
          },
          className: 'form-control b-0 p-0 form-control-lg input-contract',
        },
        {
          columInput: 2,
          campo: 'macroEstructura',
          label: 'Estructura',
          type: 'autocomplete',
          advanceOptions: { id: 'estructura2', placeholder: 'Ingrese Estructura', multiple: true, options: es },
          onChange: async () => {},
          className: 'form-control b-0 p-0 form-control-lg input-contract',
        }
      ],
      save: async (_value: any) => {
        try {
          setLoad(true)
          const { data } = await getFlaskRunPlantilla({ idContrato: id.toString() })
          const { data: dataIdJob }: any = await callSP('amd_getLogbyId', [{ text: 'id', value: data.idJob }])
          setLoad(false)
          setDataDetalle(dataIdJob.result)
          success('Proceso de regeneracion de plantilla finalizado con exito!')
          await getDataInit()
          setAlertModal(undefined)
        } catch (err) {
          setLoad(false)
          error('Error al crear la plantilla', 'bottom-center')
        }
      },
      close: () => {
        props.setAlertModal?.(undefined)
      },
    })
    setTitle(titleModal);
  }

  useEffect(() => {
    if (infoModal) {
      informationPlanings(rowLunchGrid, dataRowModal, setDataRowModal)
    }
  }, [infoModal])

  const replyAll = useCallback(() => {
    setInitialValues({
      place: [{ text: "", value: "" }],
      regime: [{ text: "", value: "" }],
      service: [{ text: "", value: "" }],
      cabecera: false,
      estructura: false,
      estructuraFija: false,
      recetaFija: false,
      frecuenciaIngredientes: false,
      reglas: false,
      plantilla: false,
      seleccionarEstructura: false,
    })
    setAlertModal(inputMinutaModal(sitios, getServices, servicios, regimens, setLoad, setAlertModal, inputSwich, estContrato))
  }, [sitios, servicios, regimens, estContrato])

  const onExport = useCallback(() => {
    exportTableToExcel("MinutaVertical0", 'Minuta Vertical0', rowLunchGrid.length);
  }, [rowLunchGrid]);

  // ==========================
  // Enroque por 2 clics (misma fila/estructura)
  // ==========================
  // Lee SIEMPRE los ingredientes ORIGINALES y cruza correctamente
  const queueSwapChanges = (rowA: any, colA: number, rowB: any, colB: number) => {
    const idA  = getFieldValue(rowA, 'idPlantilla', colA)
    const idB  = getFieldValue(rowB, 'idPlantilla', colB)

    // soporta ambas llaves que usa tu dataset
    const ingA0 = getFieldValue(rowA, 'idIngredientePrincipal',    colA) ??
                  getFieldValue(rowA, 'id_ingrediente_principal',  colA)
    const ingB0 = getFieldValue(rowB, 'idIngredientePrincipal',    colB) ??
                  getFieldValue(rowB, 'id_ingrediente_principal',  colB)

    if (!idA || !idB || ingA0 == null || ingB0 == null) {
      warn('Enroque inválido: ids o ingredientes no definidos')
      return
    }
    if (String(idA) === String(idB)) {
      warn('No se puede enrocar la misma celda')
      return
    }

    const userId = info?.id ? String(info.id) : '1'
    setChangesData(prev => [
      ...prev,
      // A debe recibir el ingrediente ORIGINAL de B
      { id: String(idA), id_ingrediente: String(ingB0), id_usuario: userId },
      // B debe recibir el ingrediente ORIGINAL de A
      { id: String(idB), id_ingrediente: String(ingA0), id_usuario: userId },
    ])
  }


  const swapAnyDaySameStructure = (
    first: Required<NonNullable<FirstSwap>>,
    second: Required<NonNullable<FirstSwap>>
  ): boolean => {
    const curr = rowLunchGrid as any[]
    const rowA = curr?.[first.idGrid]?.[first.numRow]
    const rowB = curr?.[second.idGrid]?.[second.numRow]
    if (!rowA || !rowB) {
      warn('No se encontró la fila a enrocar.')
      return false
    }

    // misma fila
    if (first.numRow !== second.numRow) {
      warn('Solo puedes enrocar dentro de la misma estructura.')
      return false
    }

    // misma estructura (soporta varias llaves)
    const structOf = (row: any, colId: number) =>
      String(
        row?.nombreEstructura ??
        row?.ess_nombre ??
        row?.['nombreEstructura' + colId] ??
        row?.['ess_nombre' + colId] ??
        ''
      ).toLowerCase().trim()

    if (structOf(rowA, first.idColumn) !== structOf(rowB, second.idColumn)) {
      warn('Solo puedes enrocar elementos de la MISMA estructura (ej: Postre 1 con Postre 1).')
      return false
    }

    // bloqueos por fijo (tu helper existente)
    if (isCellBlocked(rowA, first.idColumn) || isCellBlocked(rowB, second.idColumn)) {
      warn('No se puede enrocar: receta fija.')
      return false
    }

    // --- ejecutar swap real ---
    setRowLunchGrid((prev: any) => {
      const next = deepCopy(prev)
      const a = next[first.idGrid][first.numRow]
      const b = next[second.idGrid][second.numRow]

      queueSwapChanges(a, first.idColumn, b, second.idColumn)

      CAMPOS_X_COL.forEach((base) => {
        const kA = base + first.idColumn
        const kB = base + second.idColumn
        const tmp = a[kA]
        a[kA] = b[kB]
        b[kB] = tmp
      })

      // pila undo (tu lógica) - aumentar límite a 100 elementos con sampling inteligente
      // Para cambios importantes como enroque, siempre guardar
      try {
        const stack = JSON.parse(getLStorage('dataRowMinuta') || '[]') || []
        const MAX_STACK_SIZE = 100
        const limitedStack = stack.slice(0, MAX_STACK_SIZE - 1) // Mantener espacio para el nuevo
        setLStorage('dataRowMinuta', JSON.stringify([next, ...limitedStack]))
        changeCountRef.current += 1
        lastSaveTimeRef.current = Date.now()
      } catch (error: any) {
        console.warn('Error al guardar en stack de undo:', error)
        // Intentar guardar solo el nuevo estado
        try {
          setLStorage('dataRowMinuta', JSON.stringify([next]))
          changeCountRef.current += 1
          lastSaveTimeRef.current = Date.now()
        } catch (finalError) {
          console.error('Error crítico al guardar en stack:', finalError)
        }
      }

      return next
    })

    return true
  }


  return (
    <>
      {/* === Estilos de resaltado INDEPENDIENTES de 'color' === */}
      <style>{`
        .lv-first { 
          outline: 2px solid #F6C650;
          background: #FDE68A !important;
        }
        .lv-both { 
          background: #BFDBFE !important;
        }
      `}</style>

      <Loading open={load} />
      <HeadLunchGrid
        information={() => setInfoModal(!infoModal)}
        createMinute={true}
        onCreateMinute={() => {
          const row = params;
          props.setAlertModal?.({
            message: '¿Desea crear la minuta?',
            title: 'El contrato seleccionado no tiene minuta creada',
            initialValues: initValue,
            arrayInput: [
              {
                columInput: 2,
                id: 'desde',
                campo: 'desde',
                type: 'date',
                label: 'Desde',
                placeholder: 'Ingrese fecha desde',
                onChange: (_e: any, _setFieldValue: any, values: any) => {
                  const d: any = new Date(values['desde']).toISOString().substring(0, 10)
                  setMinDateHasta(d)
                },
              },
              {
                columInput: 2,
                id: 'hasta',
                campo: 'hasta',
                type: 'date',
                label: 'Hasta',
                placeholder: 'Ingrese fecha hasta',
                min: minDateHasta,
                disabled: false,
              },
            ],
            save: async (values: any) => {
              try {
                if (values.desde != '' && values.hasta != '') {
                  const user: any = await getUserByToken(accessToken)
                  const arrBody = [
                    { text: 'contrato', value: row.id?.toString() },
                    { text: 'desde', value: values.desde.toISOString().substring(0, 10) },
                    { text: 'hasta', value: values.hasta.toISOString().substring(0, 10) },
                    { text: 'usuario', value: user?.idUser.toString() },
                    { text: 'version', value: '2' },
                  ]
                  setLoad(true)
                  const resp = await callSP('amd_createMinuta', arrBody)
                  if (resp.data.status !== '200') {
                    const arrBodyDelete = [
                      { text: 'contrato', value: row.id?.toString() },
                      { text: 'id_minuta ', value: resp.data.result[0].id_minuta.toString() },
                    ]
                    await callSP('amd_delete_id_minuta', arrBodyDelete)
                    setLoad(false)
                    error('Error al crear la minuta', 'bottom-center')
                    return
                  }
                  if (resp.data?.result[0]?.hasOwnProperty('Response')) {
                    setLoad(false)
                    error(resp.data.result[0].Response, 'bottom-center')
                    return
                  }
    
                  let data: any = null
                  if (row.id_tipo_plantilla === 3) {
                    const respCombinado = await getFlaskRunMinuta({ idContrato: row.id, idMinuta: resp.data.result[0].id_minuta.toString() })
                    data = respCombinado.data
                  } else {
                    const respMinuta = await getFlaskRunMinuta({ idContrato: row.id, idMinuta: resp.data.result[0].id_minuta.toString() })
                    data = respMinuta.data
                  }
                  const { data: dataIdJob }: any = await callSP('amd_getLogbyId', [{ text: 'id', value: data.idJob }])
    
                  setLoad(false)
                  setDataDetalle(dataIdJob.result)
                  success('Proceso finalizado con exito!')
                } else {
                  warn('Debe seleccionar fecha desdes - hasta ')
                }
              } catch (err) {
                setLoad(false)
                error('Error al crear la minuta', 'bottom-center')
              }
            },
            close: (values: any) => {
              values.desde = ''
              values.hasta = ''
              props.setAlertModal?.(undefined)
            },
          })
        }}
        replyAll={() => {
          setInitialValues({
            place: [{ text: "", value: "" }],
            regime: [{ text: "", value: "" }],
            service: [{ text: "", value: "" }],
            cabecera: false,
            estructura: false,
            estructuraFija: false,
            recetaFija: false,
            frecuenciaIngredientes: false,
            reglas: false,
            plantilla: false,
            seleccionarEstructura: false,
          })
          setAlertModal(inputMinutaModal(sitios, getServices, servicios, regimens, setLoad, setAlertModal, inputSwich, estContrato))
        }}
        showLeyend={leyend}
        undo={() => setIsUndo(!isUndo)}
        undoAll={() => setIsUndoAll(!isUndoAll)}
        getLeyend={() => setLeyend(!leyend)}
        textPdfClient='Imprimir Plantilla Cliente'
        textExcelClient='Exportar Plantilla Cliente'
        textPdf='Imprimir Plantilla'
        textExcel='Exportar Plantilla'
        onExport={onExport}
        isMinutaVertical={true}
        getColor={() => setColor(!color)}
        getIcono={() => setIcono(!icono)}
        getNormal={() => setNormal(!normal)}
        getPrecio={() => setPrecio(!precio)}
        precio={precio}
        icono={icono}
        normal={normal}
        color={color}
        newTemplate={params?.id_tipo_plantilla != 3}
        textNewTemplate='Regenerar Plantilla'
        onNewTemplate={() => onNewTemplate(params.id)}
        showShare={true}
        onSave={onSave}
        onSaveSend={() => setShowSaveSend(true)}
        showSave={true}
        showSaveSend={true}
        showDelete={true}
        onDelete={() => {
          props.setAlertModal?.({
            message: `¿Desea eliminar la plantilla ${params?.id}?`,
            title: 'Eliminar plantilla',
            save: async () => {
              props.setAlertModal?.({
                message: `Esta acción es ireversible, ¿Desea continuar con la eliminación?`,
                title: 'Confirmar eliminar plantilla',
                save: async () => {
                  try {
                    setLoad(true)
                    const arrBody = [{ text: 'contrato', value: params.id?.toString() }]
                    const resp = await callSP('amd_delete_plantilla', arrBody)
                    if (resp.data.status !== '200') {
                      setLoad(false)
                      error('Error al eliminar la plantilla', 'bottom-center')
                      return
                    }
                    success('Plantilla eliminada con exito!')
                    props.setAlertModal?.(undefined)
                    setLoad(false)
                    navigate('/plantillas/plantillaList')
                  } catch (err) {
                    setLoad(false)
                    error('Error al eliminar la plantilla!', 'bottom-center')
                  }
                },
                close: () => props.setAlertModal?.(undefined),
              })
            },
            close: () => props.setAlertModal?.(undefined),
          })
        }}
        showExportIcon={true}
        showExportClientIcon={false}
        showExportClientIcon2={false}
        showPrintIcon={false}
        showPrintClientIcon={false}
        // pendingChanges={pendingChanges}
      />

      {/* Botón de enroque visual (2 clics) */}
      <div className="flex items-center gap-2 mb-3">
        <button
          className={`btn ${swapMode ? 'btn-primary' : 'btn-outline'}`}
          onClick={() => { setFirstSwap(null); setFirstHighlightKey(null); setSwapMode(v => !v) }}
          title="Selecciona dos celdas de la misma fila para intercambiarlas (días 1..26)"
        >
          {swapMode ? 'Cancelar enroque' : 'Enrocar celdas'}
        </button>
        {swapMode && !firstSwap && <span>Haz clic en la primera celda…</span>}
        {swapMode && firstSwap && <span>Ahora haz clic en la segunda celda (misma fila)…</span>}
      </div>

      <div style={{ display: 'flex' }}>
        <Autocomplete
          id='checkboxes-tags-demo'
          multiple
          onChange={(_event, value) =>
            setstructureSelected(value.map((item: any) => item.nombre))
          }
          isOptionEqualToValue={(option, value) => option.nombre === value.nombre}
          options={grupoEstructura}
          getOptionLabel={(option: any) => option.nombre}
          style={{ width: '50%' }}
          renderOption={(props, option, { selected }) => {
            return (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.nombre}
              </li>
            )
          }}
          renderInput={(params) => (
            <TextField {...params} label='Selección de estructura' placeholder='Estructuras' />
          )}
        />
        <Autocomplete
          id='checkboxes-tags-demo2'
          multiple
          onChange={(_event: any, value: any) =>
            setColorSelected(value.map((item: any) => item.color))
          }
          disabled={!color}
          options={optionColor}
          getOptionLabel={(option: any) => option.text}
          style={{ width: '50%' }}
          renderOption={(props: any, option: any, { selected }: any) => {
            return (
              <li {...props} style={{ backgroundColor: option.color }}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.text}
              </li>
            )
          }}
          renderInput={(params: any) => (
            <TextField
              {...params}
              onClick={() => {
                if (!color) {
                  const alert: AlertModalProps = {
                    message: 'Debe habilitar la opción color',
                    title: 'Alerta',
                    saveName: 'Aceptar',
                    showClose: false,
                  }
                  setAlertModal(alert)
                }
              }}
              label='Seleccione color'
              placeholder='Color'
            />
          )}
        />
      </div>

      {rowLunchGrid?.map((item: any, key2: number) => {
        item.forEach((item2: any) => {
          item2.colorGrupoEstructura = colorGrupoEstructura?.[item2.nombreEstructura]
        })
        return (
          <LunchGrid
            tableId={'MinutaVertical' + key2}
            totalFormularios={rowLunchGrid.length}
            nameFile={'Minuta Vertical' + key2}
            isMinutaVertical={true}
            isMinutaHorizontal={false}
            showExportIcon={false}
            colorSelected={colorSelected}
            precio={precio}
            icono={icono}
            normal={normal}
            color={color}
            newTemplate={true}
            textNewTemplate='Regenerar Minuta'
            key={key2}
            column={columnLunchGrid[key2]}
            isHeader={false}
            rows={item}

            // ======== NUEVO: datos para pintar clases sin depender de 'color' ========
            gridIndex={key2}
            firstHighlightKey={firstHighlightKey}
            highlightKeys={Array.from(highlightKeys)}

            openModal={(row, colum, numRow) => {
              // === MODO ENROQUE VISUAL (2 clics) ===
              if (swapMode) {
                const thisKey = keyOf(key2, numRow, colum.id)

                if (!firstSwap) {
                  // Primer clic -> resalto amarillo
                  if (isCellBlocked(row, colum.id)) {         
                    warn('No se puede enrocar: receta fija.')
                    return
                  }
                  setFirstSwap({ idGrid: key2, numRow, idColumn: colum.id, nombreEstructura: row?.nombreEstructura })
                  setFirstHighlightKey(thisKey)
                  return
                }

                const second = { idGrid: key2, numRow, idColumn: colum.id, nombreEstructura: row?.nombreEstructura } as Required<NonNullable<FirstSwap>>
                const first  = firstSwap as Required<NonNullable<FirstSwap>>
                
                const ok = swapAnyDaySameStructure(first, second)
                if (!ok) return  // ⛔ NO pintes azul si no hubo enroque válido

                // Terminó el enroque -> dejo ambas en azul
                const kA = keyOf(first.idGrid, first.numRow, first.idColumn)
                const kB = keyOf(second.idGrid, second.numRow, second.idColumn)
                setHighlightKeys(prev => {
                  const next = new Set(prev)
                  next.add(kA); next.add(kB)
                  return next
                })
                setFirstHighlightKey(null)
                setFirstSwap(null)
                setSwapMode(false)
                return
              }

              // === FLUJO ORIGINAL (reemplazo por modal) ===
              if (row.alertaRecetaFija) {
                const alert: AlertModalProps = {
                  message: 'No se puede editar las recetas fijas',
                  title: 'Alerta',
                  saveName: 'Aceptar',
                  showClose: false,
                  showSave: false,
                }
                setAlertModal(alert)
                return
              }
              const num = row['idIngredientePrincipal' + colum.id] ?? row['id_ingrediente_principal' + colum.id]
              // Optimizar: NO guardar dataRowB (es un array muy grande con toda la grilla que causa cuota excedida)
              // Solo guardar los datos esenciales para identificar el ingrediente seleccionado
              const json = {
                idIngrediente: num,
                idColumn: colum.id,
                fecha: row['fecha' + colum.id],
                numRow: numRow,
                id_grupo_estructura: row['id_grupo_estructura' + colum.id],
                idGrid: key2,
              }
              setIdIngredientePrincipal(json)
              setLStorage('ingredienteSeleccionado', json)
              setShowIdP(!showIdP)
              setShowModalMenu(true)
            }}
            onSave={function (): void {
              throw new Error('Function not implemented.')
            }}
            exportExternal={isExportExternal}
            onExportExternal={(val: any) => setIsExportExternal(val)}
          />
        )
      })}

      {showModalMenu && (
        <ModalForm
          show={showModalMenu}
          showSave={false}
          showClose={false}
          onSubmit={(_value: any) => { setTimeout(() => setShowModalMenu(false), 5000) }}
          close={() => setShowModalMenu(false)}
          arrayInput={[]}
          title={'Filtrar Menú'}
          showTable={true}
          tableType='datatable'
          tableSelectableRows={false}
          modalFullscreen={true}
          colum={datatableCol}
          rows={recetasbyContratoFilter}
        />
      )}

      {infoModal && (
        <ModalForm
          colum={columnDetailModal()}
          showClose={false}
          rows={dataRowModal}
          show={info}
          saveName={'Aceptar'}
          close={() => setInfoModal(false)}
          save={() => setInfoModal(false)}
        />
      )}

      {alertModal?.message !== undefined && (
        <ModalForm
          validationSchema={validateSchemaModal(title)}
          initialValues={
            alertModal.arrayInput
              ? {
                place: [{ text: '', value: '' }],
                regime: [{ text: '', value: '' }],
                service: [{ text: '', value: '' }],
                estructura2: [],
                structure: [],
                macroEstructura: [],
                cabecera: false,
                estructura: false,
                estructuraFija: false,
                recetaFija: false,
                frecuenciaIngredientes: false,
                reglas: false,
                plantilla: false,
                seleccionarEstructura: false,
              }
              : null
          }
          message={alertModal?.message}
          show={alertModal?.message !== undefined}
          title={alertModal?.title}
          saveName={alertModal?.saveName}
          showClose={alertModal?.showClose}
          showSave={alertModal.showSave}
          arrayInput={alertModal?.arrayInput}
          close={() => setAlertModal(undefined)}
          onSubmit={(value: any, _formikProps: any) => {
            setLoad(true)
            if (alertModal?.title !== title) {
              replicacionContrato(value, _formikProps, setAlertModal, params, setLoad)
            } else {
              runPlantilla(params, setAlertModal, setLoad)
            }
          }}
          save={(value: any, setFieldValue?: any, formikProps?: any) => {
            if (alertModal.save) alertModal.save(value, setFieldValue, formikProps, params)
          }}
        />
      )}

      {showSaveSend && (
        <ModalForm
          initialValues={{ ok: true, true: true }}
          size='sm'
          show={showSaveSend}
          showClose={true}
          showSave={true}
          showBody={false}
          onSubmit={() => { onSave(); setShowSaveSend(false) }}
          close={() => setShowSaveSend(false)}
          title={'Desea guardar y enviar todos los cambios?'}
          modalFullscreen={false}
        />
      )}

      <Modal
        show={forceSaveModal}
        backdrop='static'
        keyboard={false}
        centered
        size='sm'
      >
        <Modal.Header>
          <Modal.Title>Guardar cambios</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ marginBottom: 0 }}>
            Has alcanzado {MAX_PENDING_CHANGES_PLANTILLA} cambios sin guardar en la plantilla.
            Para continuar editando debes guardar los cambios.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={onSave} disabled={load}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export { MinutaVertical }

